import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { UserContext } from "../../components/UserContext";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const navigate = useNavigate(); // Hook for navigation

  const handleLoginSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload = { email, password };
      const response = await axios.post("/api/account/login", payload);
      if (response.status === 200) {
        Cookies.set("authToken", response.data.token, {
          expires: 7,
          secure: true, // HTTPS only
          sameSite: "strict", // CSRF protection
        });
        setUser(response.data); // Update the context state
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // Add this effect to handle the redirect when redirect becomes true
  useEffect(() => {
    if (redirect) {
      navigate("/");
    }
  }, [redirect]); // This runs whenever redirect changes

  useEffect(() => {
    if (user) {
      setRedirect(true);
    }
  }, [user]);
  return (
    <div className="mt-4 grow flex items-center justify-around">
      <div className="mb-64">
        <h1 className="text-4xl text-center p-4">Login</h1>
        <form
          className="flex flex-col max-w-2xl mx-auto gap-4"
          onSubmit={handleLoginSubmit}
        >
          <div className="flex flex-col gap-2">
            <input
              type="email"
              placeholder="example@email.com"
              id="username"
              name="username"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              className="input-field"
            />
          </div>
          <div className="flex flex-col gap-2">
            <input
              type="password"
              placeholder="password"
              id="password"
              name="password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              className="input-field"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-500 text-white rounded-2xl p-2"
          >
            Login
          </button>
          <div className="text-center py-2 text-gray-500">
            Don't have an account yet? &nbsp;
            <Link className="underline text-black" to={"/register"}>
              Register now
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
